import * as configConstants from '../configConstants';
import * as metaStateUtils from '../../../../store/util/metaStateUtils';

import saveGeoConfigReducer from './saveGeoConfigReducer';
import saveGlobalConfigReducer from './saveGlobalConfigReducer';
import saveUserConfigReducer from './saveUserConfigReducer';


const INITIAL_STATE = metaStateUtils.withDefaultMetaState({
    geo: {},
    global: {},
    user: {}
});


export default (state = INITIAL_STATE, action) => {

    switch (action.type) {

        case configConstants.ACTION_GEO_CONFIG_LOADED:

            return saveGeoConfigReducer(state, action.payload, false);


        case configConstants.ACTION_GEO_CONFIG_LOADING:

            return saveGeoConfigReducer(state, action.payload, true);


        case configConstants.ACTION_GLOBAL_CONFIG_LOADED:

            return saveGlobalConfigReducer(state, action.payload, false);


        case configConstants.ACTION_GLOBAL_CONFIG_LOADING:

            return saveGlobalConfigReducer(state, action.payload, true);


        case configConstants.ACTION_USER_CONFIG_LOADED:

            return saveUserConfigReducer(state, action.payload, false);


        case configConstants.ACTION_USER_CONFIG_LOADING:

            return saveUserConfigReducer(state, action.payload, true);


        default:

            return state;
    }
};
